interface MenuDividerProps {
  margin?: string;
}

function MenuDivider({ margin = '8px' }: MenuDividerProps) {
  return (
    <div
      style={{
        height: '1px',
        backgroundColor: 'var(--color-divider)',
        margin
      }}
    />
  );
}

export default MenuDivider;
